/**
 * @author Brendan Magee
 * @desc Arc Nav directive
 * @example <arc-nav></arc-nav>
 */

function arcNav($document, $location, arcNavConfig) {
  const [document] = Array.from($document);

  return {
    restrict: 'E',
    template: '',
    replace: true,
    link() {
      const path = $location.path();
      const externalSystem = path === '/pitch-form' || path === '/task-form';

      if (!externalSystem) {
        arcNavConfig.getConfigData().then((data) => {
          const srcScript = document.createElement('script');
          srcScript.src = 'https://nav-prod.home.static.arcpublishing.com/js/arcnav-standalone.js';
          srcScript.async = true;

          const nav = document.createElement('script');
          nav.type = 'application/json';
          nav.id = 'navbar';
          const config = document.createTextNode(data);
          nav.appendChild(config);

          document.body.insertBefore(nav, document.body.children[0]);
          document.head.appendChild(srcScript);
        });
      }
    }
  };
}


export default function (ngModule) {
  ngModule.directive('arcNav', [
    '$document',
    '$location',
    'arcNavConfig',
    arcNav
  ]);
}
